// extracted by mini-css-extract-plugin
export var askAiIcon = "_qj-9";
export var container = "_qj-0";
export var groupSeparator = "_qj-a";
export var highlight = "_qj-4";
export var resultIcon = "_qj-5";
export var resultItem = "_qj-7";
export var resultSubtitle = "_qj-3";
export var resultTitle = "_qj-2";
export var resultsList = "_qj-1";
export var searchGroup = "_qj-6";
export var selected = "_qj-8";